import { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router';

export const ScrollToTop = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};
